import { fetchFilterPageItemRecommendations } from './recommendations'

export default {
  namespaced: true,
  state: {
    miniCartItems: [],
    miniCartSkus: [],
    miniCartRecIsLoading: false,
    initialisedByDy: false,
  },

  mutations: {
    setMiniCartItems(state, payload) {
      state.miniCartItems = payload
    },
    setMiniCartSkus(state, payload) {
      state.miniCartSkus = payload
    },
    setMiniCartRecIsLoading(state, payload) {
      state.miniCartRecIsLoading = payload
    },
    setInitialisedByDy(state, payload) {
      state.initialisedByDy = payload
    },
  },

  actions: {
    fetchData({ state, commit }, payload) {
      const args = state.miniCartSkus.length
        ? { skus: state.miniCartSkus }
        : { excludeProductId: payload ? payload.excludeProductId : null }

      fetchFilterPageItemRecommendations(args).then(items => {
        commit('setMiniCartItems', items)
        commit('setMiniCartRecIsLoading', false)
        On.DynamicYield.resetRecommendationContext()
      })
    },
    setMiniCartSkusByDy({ commit }, payload) {
      if (!On.DynamicYield.shouldUpdateRecommendation) return

      commit('setInitialisedByDy', true)
      commit('setMiniCartSkus', payload)
    },
  },

  getters: {
    miniCartItems: state => state.miniCartItems,
    miniCartSkus: state => state.miniCartSkus,
    miniCartRecIsLoading: state => state.miniCartRecIsLoading,
    initialisedByDy: state => state.initialisedByDy,
  },
}
